module.exports = __webpack_public_path__ + "media/src/images/site-top/image3-a4e901d555ee2d7c0d9232698974b468.jpg";